import { ReactElement } from "react";
import { TFunction, withTranslation } from "react-i18next";
import { useModel, useEmptyClearFilterModel } from "../../contexts/modelContextNew";
import BaseField from "./baseFieldNew";
import { IPropsInputField } from "./fieldPropertiesInterfaceNew";
import modelHelper from "./modelHelperNew";

interface IPropsType {
  type: string;
  prefix?: ReactElement;
  sufix?: ReactElement;
  t: TFunction;
  hideSingleClearState?: boolean;
  isClassicInput?: boolean;
}

type IPropsInputFieldWithType = IPropsInputField & IPropsType;

function InputField({
  type,
  model,
  attr,
  value,
  label,
  placeholder,
  isTextArea,
  onChange,
  disabled,
  required,
  autoFocus,
  prefix,
  sufix,
  isError,
  isClassicInput,
  t,
  hideSingleClearState
}: IPropsInputFieldWithType) {

  const modelContext = useModel();
  const emptyClearStates = useEmptyClearFilterModel();
  const modelState = model || modelContext;
  const { onValueChange, getTextValue, singleClearState } = modelHelper({ model: modelState, attr, value, onChange, emptyClearStates}); // modelState: useModel()

  return (
    <BaseField attr={attr} isError={isError} label={label || ""} required={required} value={getTextValue()} prefix={prefix} sufix={sufix} hideSingleClearState={hideSingleClearState} onClearState={singleClearState} isClassicInput={isClassicInput}>
      {!isTextArea?
      <input
        id={`input-${attr}`}
        type={type}
        value={getTextValue()}
        onChange={onValueChange}
        title={label ? t(label) : ""}
        autoComplete="off"
        placeholder={placeholder}
        autoFocus={autoFocus}
        required//Para que detecte cambio y agregue el border de error
        disabled={disabled}
        />:
          <textarea
              id={`input-${attr}`}
              value={getTextValue()}
              onChange={onValueChange}
              title={label ?t(label) : ""}
              autoComplete="off"
              placeholder={placeholder}
              autoFocus={autoFocus}
              disabled={disabled}
              required //Para que detecte cambio y agregue el border de error
          />
      }
    </BaseField>
  );
}

export default withTranslation() (InputField);